import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import _isEqual from 'lodash/isEqual';

import { Listing as ListingSchema } from '@atc/react-schemas';

import { Col } from 'reaxl';
import {
    InventoryListingPlaceholder,
    InventoryListingV2,
} from 'reaxl-listing';

import configureListingTiles from '@/utilities/configureListingTiles';
import useInventoryListingProps from '@/utilities/useInventoryListingProps';

import srpSpotlightDuck from '@/ducks/srp/srpSpotlightDuck.js';

function InventorySpotlightContainer({
    baseUrl,
    schemaTemplate,
    schemaType,
    userLocation,
    currentPage,
    listingIndex,
    listingId,
    brand,
    certifiedSponsor,
    isOverrideCarfaxTileEnabled,
    partner,
    removeCarfaxTile,
    removeExperianTile,
}) {
    const isSpotlightsLoading = useSelector(srpSpotlightDuck.selectors.getResultLoading);

    const spotlightProps = {
        listingIndex,
        brand,
        certifiedSponsor,
        isOverrideCarfaxTileEnabled,
        partner,
        removeCarfaxTile,
        removeExperianTile,
    };

    // Getting the specific spotlight base on index and configure it
    const spotlight = useSelector((state) => srpSpotlightDuck.selectors.getIndividualSpotlight(state, listingId));
    const spotlightListing = !!spotlight && configureListingTiles({
        ...spotlightProps,
        tier: 'spotlight',
        items: [spotlight],
    });
    const currentSpotlight = spotlightListing[0];

    const resultsCount = useSelector(srpSpotlightDuck.selectors.getActiveResultsCount);
    const paginatedListingIndex = (listingIndex && (listingIndex + 1) + ((currentPage - 1) * resultsCount)) || undefined;

    const getListingProps = useInventoryListingProps();
    const listingProps = getListingProps('spotlight', currentSpotlight, listingIndex, paginatedListingIndex);
    currentSpotlight.owner = listingProps.listing.owner;

    const spotlightContainer = isSpotlightsLoading ? (
        <Col
            xs={12}
            sm={6}
            md={4}
            key={`spotlight-placeholder-${listingIndex}`}
        >
            <InventoryListingPlaceholder
                data-cmp="inv-placeholder-spotlight"
            />
        </Col>
    ) : (
        <Col
            xs={12}
            sm={6}
            md={4}
            className="display-flex"
            key={`spotlight-container-${listingIndex}`}
        >
            <ListingSchema
                key={currentSpotlight.id}
                inventory={currentSpotlight}
                baseUrl={baseUrl}
                schemaTemplate={schemaTemplate}
                schemaType={schemaType}
                searchLocation={userLocation}
            />
            <InventoryListingV2
                data-cmp="inventorySpotlightListing"
                {...listingProps}
            />
        </Col>
    );

    return currentSpotlight ? spotlightContainer : null;
}

InventorySpotlightContainer.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    schemaTemplate: PropTypes.object.isRequired,
    schemaType: PropTypes.string.isRequired,
    userLocation: PropTypes.object.isRequired,
    currentPage: PropTypes.number.isRequired,
    listingIndex: PropTypes.number.isRequired,
    listingId: PropTypes.string,
    brand: PropTypes.string.isRequired,
    certifiedSponsor: PropTypes.bool.isRequired,
    isOverrideCarfaxTileEnabled: PropTypes.bool.isRequired,
    partner: PropTypes.bool.isRequired,
    removeCarfaxTile: PropTypes.bool.isRequired,
    removeExperianTile: PropTypes.bool.isRequired,
};

export default memo(InventorySpotlightContainer, _isEqual);
